<template>
  <ul>
    <li
      v-for="(item, index) in navList"
      :key="index"
      @click="goUrl(item, index)"
      :class="[
        idx === index ? 'sunshine-active' : '',
        index === 0 ? 'home' : 'item-li'
      ]"
    >
      {{ item.label }}
    </li>
  </ul>
</template>

<script>
export default {
  props: ["navList"],
  data() {
    return {
      idx: 1
    };
  },
  methods: {
    goUrl(item, index) {
      if (item.disabled) return;
      this.idx = index;
      this.$router.push(item.path);
      document.documentElement.scrollTop = 0;
    }
  },
  watch: {
    $route() {
      const path = this.$route.fullPath;
      const index = this.navList.findIndex(item => item.path === path);
      this.idx = index;
    }
  },
  created() {
    let path = "";
    path = this.$route.fullPath;
    const index = this.navList.findIndex(item => item.path === path);
    if (index !== -1) {
      this.idx = index;
    }
  }
};
</script>

<style scoped>
ul {
  width: 295px;
}

ul > li {
  width: 295px;
  height: 64px;
  background: #eef0f4;
  font-size: 22px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #34373b;
  line-height: 64px;
  margin: 2px 0;
  padding-left: 30px;
  cursor: pointer;
}
ul > .sunshine-active,.item-li:hover {
  width: 310px;
  background: url("../../../../assets/images/BTOC/xz.png") no-repeat left;
  background-size: 310px 64px;
  font-size: 22px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
}
ul > .home {
  font-size: 28px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  background: #eaeaea;
}

.port-nav {
  margin-right: 27px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/BToB/common/menuComBToB.vue